import { getApis } from 'library/Apis';
import { EducadorBody } from 'models/users';
import { toRequest } from 'utils/RequestUtils';
import api from './api';
import { loadedAssessorData } from 'store/modules/EscolasActions';
import { Dispatch } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';

const getEndpoint = (version: number, path = '/') => {
  return `${getApis().apis.bff}v${version}${path}`;
};

export const getAssessoresByCoop = (
  coop: string,
  valorDoCampo: string[] = []
) => {
  const url = getEndpoint(1, `/assessor/cooperativa/${coop}`);
  return toRequest('post', [url, valorDoCampo]);
};

export const getEducadoresByCoop = (body: EducadorBody) => {
  const url = getEndpoint(1, `/educador/educadores`);
  return toRequest('post', [url, body]);
};

export const getAssessorByCpf = (cpf: string) => async (dispatch: Dispatch) => {
  try {
    const url = getEndpoint(1, `/assessor/${cpf}`);
    const response = await api.get(url);
    dispatch(loadedAssessorData(response.data));
  } catch (error) {
    SnackbarUtils.enqueueSnackbar({
      message: `Erro ao buscar assessor:`, error,
      options: {
        variant: 'error',
      },
    });
  }
};

